import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface CartAlreadyOrderedDialogProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Shown when placing an order returns HTTP 409 — the cart had already been
 * ordered. The backend issues a fresh cart with the items restored; this
 * dialog explains what happened and what the user should do next.
 */
export function CartAlreadyOrderedDialog({
  open,
  onClose,
}: CartAlreadyOrderedDialogProps) {
  const { t } = useTranslation('cart');

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('alreadyOrdered.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('alreadyOrdered.description')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} size="small" variant="contained" autoFocus>
          {t('alreadyOrdered.action')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
